import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { CommonConstant } from 'src/shared/constants/common.constants';
import { environment } from '../environments/environment';
import { BaseComponent } from '../shared/components/base-component/base.component';
import { FavieWebAdminHeaderInput } from '../shared/components/header/interfaces/favie-web-admin-header-input.interface';
import { SidebarItem } from '../shared/components/sidebar/sidebar-item.interface';
import { SidebarLogo } from '../shared/components/sidebar/sidebar-logo.interface';
import { FavieAuthService } from '../shared/services/auth/favie-auth.service';
import { NgSwCheckForUpdateService } from '../shared/services/service-worker/ngsw-check-for-update.service';
import { NgSwLogUpdateService } from '../shared/services/service-worker/ngsw-log-update.service';
import { NgSwPromptUpdateService } from '../shared/services/service-worker/ngsw-prompt-update.service';
import { AppService } from './services/app.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    {provide: MAT_DATE_FORMATS, useValue: CommonConstant.DATE_PICKER_FORMATS},
  ]
})
export class AppComponent extends BaseComponent {
  public headerInput: FavieWebAdminHeaderInput;
  public sidebarLogo: SidebarLogo;
  public sidebarItems: SidebarItem[] = [];

  constructor(
    private readonly favieAuthService: FavieAuthService,
    private readonly appService: AppService,
    @Inject(PLATFORM_ID) private platformId,
    private readonly ngSwLogUpdateService: NgSwLogUpdateService,
    private readonly ngSwCheckForUpdateService: NgSwCheckForUpdateService,
    private readonly ngSwPromptUpdateService: NgSwPromptUpdateService,
  ) {
    super();
  }

  onInit() {
    console.log(`App version: ${environment.version}`);
    this.initHeader();
    this.initSidebar();
    this.initNgSw();
    this.setAppHeight();
  }

  private initHeader() {
    const subscription = this.favieAuthService.getLogged().subscribe((isLogged: boolean) => {
      this.headerInput = {};
      this.appService.getAppHeaderInput(isLogged, this.headerInput);
      this.sidebarItems = isLogged ? this.appService.getAppSidebarItems() : [];
    });
    this.addSubscription(subscription);
  }

  private initSidebar() {
    this.sidebarLogo = this.appService.getAppSidebarLogo();
  }

  private initNgSw() {
    if (environment.production && isPlatformBrowser(this.platformId)) {
      this.ngSwLogUpdateService.init();
      this.ngSwCheckForUpdateService.init();
      this.ngSwPromptUpdateService.init();
    }
  }

  private setAppHeight() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const appHeight = () => {
      const doc = document.documentElement;
      doc.style.setProperty(
        '--app-height',
        `${doc.clientHeight}px`,
      );
    };
    window.addEventListener('resize', appHeight);
    appHeight();
  }
}
